import React from 'react';
import { cn } from '../../utils/tailwindUtils';

/**
 * Base surface card — dark-mode aware, consistent spacing/borders.
 * Replaces the mix of `bg-white border border-gray-100` patterns.
 */
const Surface = React.forwardRef(function Surface(
  { as: Tag = 'div', className, padding = 'md', interactive = false, children, ...rest },
  ref
) {
  const pad = { none: '', sm: 'p-3', md: 'p-5', lg: 'p-6' }[padding] || 'p-5';
  return (
    <Tag
      ref={ref}
      className={cn(
        'rounded-2xl border bg-card text-card-foreground border-border',
        'shadow-[0_1px_2px_rgba(0,0,0,0.04)] dark:shadow-[0_1px_2px_rgba(0,0,0,0.4)]',
        'transition-all duration-200',
        interactive && 'cursor-pointer hover:-translate-y-0.5 hover:shadow-md hover:border-primary/30',
        pad,
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
});

export default Surface;
